import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './components/Home';
import Products from './components/Products';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <nav className="p-4 bg-blue-700 text-white flex justify-between items-center shadow-md">
          <div className="flex items-center space-x-4">
            <Link to="/">
              <img   src="/dalcom-logo.png" alt="Dalcom Logo" className="h-20" />
            </Link>
            <span className="text-2xl font-bold hidden sm:inline">Dalcom</span>
          </div>
          <div className="flex space-x-6 text-lg">
            <Link to="/" className="hover:underline">Home</Link>
            <Link to="/products" className="hover:underline">Products</Link>
          </div>
        </nav>

        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
          </Routes>
        </div>

        <footer className="text-center p-4 bg-gray-100 text-gray-600">
          <p>© 2025 Dalcom Ltd. All rights reserved.</p>
          <p>Contact us: info@dalcom.co.uk | +44 7592 586 486 | Company Reg No: 16344098</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;